export default __webpack_public_path__ + "static/media/Horizontal - 108.6b4cacd9.svg";